import { render } from "./Printers.vue?vue&type=template&id=1d512402&scoped=true&ts=true"
import script from "./Printers.vue?vue&type=script&lang=ts"
export * from "./Printers.vue?vue&type=script&lang=ts"

import "./Printers.vue?vue&type=style&index=0&id=1d512402&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d512402"]])

export default __exports__